import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import CategoriesDiscountList from "src/components/panel/children_categories/categories_discount/CategoriesDiscountList";

const CategoriesDiscountListView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("categories_discount_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("categories_discount_title")}
          subtitle={t("categories_discount_subtitle")}
        />
        <CategoriesDiscountList />
      </Sidebar>
    </>
  );
};

export default CategoriesDiscountListView;
